// extracted by mini-css-extract-plugin
export default {"outerDiv":"login-page_outerDiv__NuVyR","yuvaImg":"login-page_yuvaImg__gYNFs","dualBannerWrap":"login-page_dualBannerWrap__4OmCP"};